import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const calculateRemainingTime = (expirationTime: string | null) => {
  if (expirationTime === null) return 0;
  const currentTime = new Date().getTime();
  const adjustedExpirationTime = +expirationTime;
  const remainingTime = adjustedExpirationTime - currentTime;
  return remainingTime;
};

const retrieveStoredToken = () => {
  const initialToken = localStorage.getItem("token");
  const initialExpirationTime = localStorage.getItem("expirationTime");
  const initialUserId = localStorage.getItem("uid");
  const initialRefreshToken = localStorage.getItem("refreshToken");

  const remainingTime = calculateRemainingTime(initialExpirationTime);

  if (remainingTime <= 0) {
    localStorage.removeItem("token");
    localStorage.removeItem("expirationTime");
    localStorage.removeItem("uid");

    return {
      token: null,
      uid: null,
      duration: 0,
      refreshToken: initialRefreshToken,
    };
  }

  return {
    token: initialToken,
    uid: initialUserId,
    duration: remainingTime,
    refreshToken: initialRefreshToken,
  };
};

let storageToken: string | null = "";
let storageDuration = 0;
let storageUID: string | null = '';
let storageRefreshToken: string | null = '';
const authTokenData = retrieveStoredToken();
if (authTokenData !== null) {
  storageToken = authTokenData.token;
  storageDuration = authTokenData.duration;
  storageUID = authTokenData.uid;
  storageRefreshToken = authTokenData.refreshToken;
}

export type authState = {
  token: string;
  expiresIn: number;
  uid: string;
  refreshToken: string;
};

const authSlice = createSlice({
  name: "auth",
  initialState: {
    token: storageToken,
    expiresIn: storageDuration,
    uid: storageUID,
    refreshToken: storageRefreshToken,
  },
  reducers: {
    login(
      state,
      action: PayloadAction<{
        token: string;
        expirationTime: string;
        localId: string;
        refreshToken: string;
      }>
    ) {
      state.token = action.payload.token;
      localStorage.setItem("token", action.payload.token);
      state.uid = action.payload.localId;
      localStorage.setItem("uid", action.payload.localId);
      state.refreshToken = action.payload.refreshToken;
      localStorage.setItem("refreshToken", action.payload.refreshToken);

      const currentTime = new Date().getTime();
      const tokenExpirationTime = currentTime + (+action.payload.expirationTime) * 1000;

      localStorage.setItem("expirationTime", tokenExpirationTime.toString());

      state.expiresIn = +action.payload.expirationTime * 1000;
    },
    logout(state) {
      localStorage.removeItem("token");
      localStorage.removeItem("expirationTime");
      localStorage.removeItem("uid");
      localStorage.removeItem("refreshToken");
      state.token = "";
      state.expiresIn = 0;
      state.uid = "";
      state.refreshToken = "";
    },
  },
});

export default authSlice.reducer;
export const AuthActions = authSlice.actions;
